// @flow

import type { Node } from "react";
import React from "react";

import { BruImage } from "@/components";
import { classNameOf } from "@/utils";
import JsonPageRenderer from "@/utils/JsonPageRenderer/JsonPageRenderer";
import type { ItemRenderer, PageItem } from "@/utils/JsonPageRenderer/types";

interface ImagePageItem extends PageItem {
    props: {
        [string]: any,
        className?: string,
        width?: number,
        height?: number,
        src: string,
        alt: string,
    };
}

/**
 * Converts an ImagePageItem into a <img> node.
 */
class RowRenderer implements ItemRenderer<ImagePageItem> {
    render(context: JsonPageRenderer, item: ImagePageItem): Node {
        const className = classNameOf(item.props.className || "");
        const style: {
            [key: string]: any
        } = {};
        if (typeof item.props.width === "number") {
            style.width = `${item.props.width}px`;
        }
        if (typeof item.props.height === "number") {
            style.height = `${item.props.height}px`;
        }
        const image = context.findImageSource(item.props.src);

        if (image == null) {
            throw new Error(`No image found for ${item.props.src}`);
        }

        if (typeof image === "string") {
            return (
                <img
                    key={item.id}
                    style={style}
                    className={className}
                    src={image}
                    alt={item.props.alt}
                />
            );
        }

        return (
            <BruImage
                key={item.id}
                className={className}
                image={image}
                style={style}
                alt={item.props.alt}
            />
        );
    }

    match(item: PageItem): ImagePageItem | null {
        if (item.type === "image") {
            return item;
        }
        return null;
    }
}

export default RowRenderer;
